import React from 'react'
import { render } from 'react-dom'
import Home from './home'
import axios from 'axios'
import CEFTransfer from 'src/commons/utils/CEFTransfer'
import './index.css'
import { sendMessageToMainClient } from 'src/commons/utils'
import SpeedBallStore from 'src/pc/store/SpeedBallStore'

axios.defaults.withCredentials = true
axios.defaults.headers = {
  Platform: 'simple',
  box: !!window.FuluApp,
  'Cache-Control': 'cache',
  terminal: 'pc',
  'front-version': '2.0.0',
}
CEFTransfer()
render(<Home />, document.getElementById('root'))
//通知客户端加载完成
window.FuluApp?.JSNotifyCppFunc('ui_load_complete')
//获取主窗口token
!SpeedBallStore.token && sendMessageToMainClient('getToken')
